/* eslint-disable no-undef */
import React from 'react';
import MediaQuery from 'react-responsive';
import OrderForm from '../../../containers/OrderFormWrapper/OrderFormWrapper';
import BenefitsSideBlock from '../../BenefitsSideBlock';
import SideSteps from '../../Steps/SideSteps';
import * as media from '../../../constants/mediaQueries';

const DetailsRightPart = () => (
  <div className="row rightPart">
    <MediaQuery minWidth={media.SCREEN_MD_MIN}>
      <div className="col-sm-6 col-md-12">
        <OrderForm noScroll />
      </div>
    </MediaQuery>
    <div className="col-sm-6 col-md-12">
      <BenefitsSideBlock />
    </div>
    <div className="col-sm-6 col-md-12">
      <SideSteps />
    </div>
  </div>
);

export default DetailsRightPart;
